/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceCountByCategory {
    getFixupPrototypeFunction() { return ResourceCountByCategory.fixupPrototype; }

    static newInstance(model: Partial<ResourceCountByCategory>): ResourceCountByCategory {
        let obj = Object.assign(new ResourceCountByCategory(), model);
        ResourceCountByCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceCountByCategory>): ResourceCountByCategory {
        if (!model) return null;
        return ResourceCountByCategory.newInstance(<ResourceCountByCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceCountByCategory) {
        if (!obj) return;

        models.ResourceCountByCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceCountByCategory): boolean {
        Object.setPrototypeOf(obj, ResourceCountByCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.open === undefined) {
            this.open = 0;
        }
    }

    /**
     * Resource count that are open
     */
    open: number;

}
